import {DotPath} from '../getOrElse'
import {getDefinedOrElse} from './getter'
import {Decorators} from '../config/getterConfig'
import {decorate} from './decorator'
import { Log } from '../log/logger'

export function arrayOr<R, T extends any>(
  root: R,
  path: DotPath = '',
  decorators: Decorators<T[]> = [],
  orElse = [] as T[]
) {
  Log.info('Root ', root, ' path ', path)
  Log.info(decorators)
  const array: T[] = [].concat(
    getDefinedOrElse(root, path, orElse)
  ).map(el => decorate(el, decorators))
  return array.concat(orElse.slice(array.length))
}